import { useNavigate } from '@tanstack/react-router';

import { Button } from '../../../../cdl/Button/Button';
import { StatePlaceholder } from '../../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconContract } from '../../../../common/icons/cdl/Contract';
import { Box } from '../../../../common/ui/Box';

export const VesselContractsEmptyState = () => {
    const navigate = useNavigate();

    return (
        <Box display="flex" justifyContent="center" paddingTop="124px">
            <StatePlaceholder
                Icon={IconContract}
                title={translate('vessel.contracts.emptyState.title')}
                description={translate('vessel.contracts.emptyState.description')}
                action={
                    <Button onClick={() => navigate({ to: '/contracts' })}>
                        {translate('vessel.contracts.emptyState.action')}
                    </Button>
                }
            />
        </Box>
    );
};
